export default __webpack_public_path__ + "static/media/excel1.bb2ba0f0.png";